
import { formatCurrency } from '@/lib/utils';

interface NetPayDisplayProps {
  netSalary: number;
}

export const NetPayDisplay = ({ netSalary }: NetPayDisplayProps) => {
  return (
    <div className="p-6 border b border-gray-400 my-2 rounded-md bg-gray-200">
      <div className="flex justify-between items-center">
        <span className="text-lg font-bold">Net Pay Paid</span>
        <span className="text-xl font-bold text-green-600">{formatCurrency(netSalary)}</span>
      </div>
    </div>
  );
};
